module.exports = __webpack_public_path__ + "static/media/Gallery-10.cf735d97.jpg";